import getYesNoQuestionsAllSaga from './get';

export default [getYesNoQuestionsAllSaga];
